import styled from "styled-components";

export const RequestStyle = styled.div`
  margin-inline: 20px;
  padding-block: 50px;
  height: calc(100vh - 110px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledChart = styled.div`
  img {
    fill: #ff0000; /* Change the fill color to your desired color */
  }
`;